module.exports = __webpack_public_path__ + "static/media/17e5e219-693a-4fd9-b57f-ed9b4d7bafb5.428100b2.JPG";